export * from './data-zoom';
export * from './type';
